import { useMemo } from 'react';
import { useTaskStateType } from '@sierralabs/workflow-ui';
export function useFileVersionLabel(file, checkFileVersion = true) {
    const { isFinal } = useTaskStateType(file === null || file === void 0 ? void 0 : file.task);
    const version = useMemo(() => {
        const { version: fileVersion } = (file === null || file === void 0 ? void 0 : file.fileVersion) || {};
        if (checkFileVersion && fileVersion) {
            return fileVersion;
        }
        // apply version - 1 if state is final
        // use task.version instead of file.version
        const { version: taskVersion } = (file === null || file === void 0 ? void 0 : file.task) || {};
        return taskVersion && taskVersion - +isFinal;
    }, [isFinal, file, checkFileVersion]);
    return { version, isFinal };
}
//# sourceMappingURL=useFileVersionLabel.js.map